export const SHIPPING=5.55
export const TAXES=5
export const ITEMS_PER_PAGE=10

export const ONLINE_PAYMENT_ACCOUNTS = {
  hbl: {
    bankName: 'HBL',
    accountTitle: 'NEXOCART',
    accountNumber: '04897903603003',
  },
  easyPaisa: {
    accountTitle: 'Sardar laeiq Ahmed',
    number: '03448252109',
  },
}